import { settings } from "../config/settings";

const TICKET_ID_PATTERN = /View_Ticket[=\/](\d+)/i;

export function parseTicketIdFromLocation(location = window.location) {
  const { pathname, search, hash } = location;

  let match = pathname.match(TICKET_ID_PATTERN);
  if (match) {
    return match[1];
  }

  if (search) {
    const params = new URLSearchParams(search);
    for (const [key, value] of params.entries()) {
      if (/^View_Ticket$/i.test(key) && /^\d+$/.test(value)) {
        return value;
      }
    }

    match = search.match(TICKET_ID_PATTERN);
    if (match) {
      return match[1];
    }
  }

  if (hash) {
    match = hash.match(TICKET_ID_PATTERN);
    if (match) {
      return match[1];
    }
  }

  return null;
}

export function buildTicketDeepLinkPath(ticketId) {
  return `/View_Ticket=${ticketId}`;
}

function getPendingStorageKey() {
  return settings.STORAGE_KEYS.PENDING_TICKET_REDIRECT;
}

export function savePendingTicketRedirect(ticketId) {
  if (ticketId) {
    sessionStorage.setItem(getPendingStorageKey(), String(ticketId));
  }
}

export function consumePendingTicketRedirect() {
  const key = getPendingStorageKey();
  const ticketId = sessionStorage.getItem(key);
  if (ticketId) {
    sessionStorage.removeItem(key);
  }
  return ticketId;
}

export function clearPendingTicketRedirect() {
  sessionStorage.removeItem(getPendingStorageKey());
}
